import { Component, Input } from '@angular/core';
import { AbstractValueAccessor, MakeProvider } from '../abstract-value-accessor';

@Component({
    selector: 'app-input-box',
    templateUrl: './input-box.component.html',
    styleUrls: ['./input-box.component.scss'],
    providers: [MakeProvider(InputBoxComponent)],
    standalone: false
})
export class InputBoxComponent extends AbstractValueAccessor {
  @Input() textBoxId: string;
  @Input() inputType = 'text';
  @Input() placeholder = '';
  @Input() errorText = '';
  @Input() labelText = '';
  @Input() min: number = Number.NEGATIVE_INFINITY;
  @Input() max: number = Number.POSITIVE_INFINITY;
  @Input() formControlName = '';
  @Input() name = '';
  @Input() invalid = false;

  propagateText($event: any): void {
    this.onChange($event.target.value);
  }
}
